import { render, staticRenderFns } from "./ControleBnpMensal.vue?vue&type=template&id=58592836&scoped=true&"
import script from "./ControleBnpMensal.vue?vue&type=script&lang=js&"
export * from "./ControleBnpMensal.vue?vue&type=script&lang=js&"
import style0 from "./ControleBnpMensal.vue?vue&type=style&index=0&id=58592836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58592836",
  null
  
)

export default component.exports